export default "__VITE_ASSET__Cj7ljwX2__"